import React, { SVGProps } from "react";

export const JiraMarkBrandInverse = ({
  width = "100%",
  height = "100%",
}: Pick<SVGProps<SVGSVGElement>, "height" | "width">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="4.5120000000000005 7.103999999999999 37.344 37.824"
    width={width}
    height={height}
  >
    <g id="Container">
      <path
        fill="#FFFFFF"
        d="M16.5504 32.6743H13.2216C8.20121 32.6743 4.59961 29.5992 4.59961 25.0964H22.4984C23.4261 25.0964 24.0264 25.7554 24.0264 26.6889V44.7C19.5517 44.7 16.5504 41.0758 16.5504 36.0239V32.6743ZM25.3906 23.7236H22.0619C17.0415 23.7236 13.4399 20.7034 13.4399 16.2007H31.3387C32.2664 16.2007 32.9213 16.8047 32.9213 17.7382V35.7493C28.4465 35.7493 25.3906 32.1251 25.3906 27.0732V23.7236ZM34.2855 14.8279H30.9567C25.9363 14.8279 22.3347 11.7528 22.3347 7.25H40.2336C41.1613 7.25 41.7615 7.90894 41.7615 8.78754V26.7987C37.2868 26.7987 34.2855 23.1745 34.2855 18.1226V14.8279Z"
      />
    </g>
  </svg>
);

export default JiraMarkBrandInverse;
